import React from 'react';
import {Atom} from '@packages/systems/wfdl';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';

const UserFormFooter = Atom.createRender(
  ({data, generateAttributes, attributes, classes, renderChild}) => (
    <div {...generateAttributes(attributes, classes)}>
      {getChildren(data).map((child) => renderChild(child))}
    </div>
  )
);

const config = createIntegratedAtom({
  displayName: 'Form Footer',
  showEmpty: true,
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: px(12),
        },
      },
    },
  },
  render: UserFormFooter,
  fields: {children: TListOfElement},
});

export default config;
